import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthRepositoryImpl } from '../Data/repositories/AuthRepositoryImpl';
import { LoginUseCase } from '../Domain/UseCase/LoginUseCase';
import { MeUseCase } from '../Domain/UseCase/MeUseCase';
import { RefreshTokenUseCase } from '../Domain/UseCase/RefreshTokenUseCase';
import { SLOT_OPS_OVERRIDE_TOKEN_KEY } from '../../../Utils/limitedPartnerAdmin';

const repo = new AuthRepositoryImpl();

export const loginThunk = createAsyncThunk(
  'auth/login',
  async ({ username, password }: { username: string; password: string }, { dispatch }) => {
    // 기존 로컬 토큰/상태 초기화 및 Redux 상태 초기화 후 새 로그인 시도
    dispatch({ type: 'auth/logout' });
    return new LoginUseCase(repo).execute(username, password);
  },
);

export const initAuthThunk = createAsyncThunk('auth/init', async () => {
  const acc = localStorage.getItem('access');
  const ref = localStorage.getItem('refresh');
  if (!acc || !ref) return null;
  const user = await new MeUseCase(repo).execute();
  return { access: acc, refresh: ref, user };
});

export const refreshTokenThunk = createAsyncThunk('auth/refresh', async () => {
  const refresh = localStorage.getItem('refresh');
  if (!refresh) throw Error();
  const { access } = await new RefreshTokenUseCase(repo).execute(refresh);
  return access;
});

export const refreshMeThunk = createAsyncThunk('auth/refreshMe', async () => {
  return new MeUseCase(repo).execute();
});

export const slotOpsOverrideThunk = createAsyncThunk(
  'auth/slotOpsOverride',
  async (password: string) => {
    const result = await repo.slotOpsOverride(password);
    sessionStorage.setItem(SLOT_OPS_OVERRIDE_TOKEN_KEY, result.override_token);
    return new MeUseCase(repo).execute();
  },
);

export const clearSlotOpsOverrideThunk = createAsyncThunk('auth/clearSlotOpsOverride', async () => {
  sessionStorage.removeItem(SLOT_OPS_OVERRIDE_TOKEN_KEY);
  return new MeUseCase(repo).execute();
});
